export default __webpack_public_path__ + "static/media/upload.5b0f6cc2.svg";